import React, { useRef, useState, useEffect } from 'react';
import '../../slider.css';

import { ImageRows, TopArea } from './imageRow.jsx';
import PinChild from './PinChild.jsx';
import Dropdown from './Dropdown.jsx';
import ImageSlider from "./ImageSlider.jsx";
import TopMenuBar from './TopMenuBar.jsx';

import { Beforeunload } from 'react-beforeunload';

const PinContent = ({ content, cb, closePanel, initialSelectedIndex }) => {
  const [selectedIndex, setSelectedIndex] = useState(initialSelectedIndex);
  const [imageLoaded, setImageLoaded] = useState(false);
  const contentRef = useRef(null);

  // 메뉴바(TopMenuBar) 컨테이너 ref 추가
  const menuBarContainerRef = useRef(null);

  useEffect(() => {
    if (initialSelectedIndex !== -1) {
      setSelectedIndex(initialSelectedIndex);
      scrollToDiv(initialSelectedIndex);
      scrollMenuItemToCenter(initialSelectedIndex);
    }
    // eslint-disable-next-line
  }, [imageLoaded]);

  // 초기 렌더링 시 content나 content.children이 undefined일 경우를 고려하여 안전하게 처리
  const divRefs = useRef(
    [...Array(content && content.children ? content.children.length : 0)].map(
      () => React.createRef()
    )
  );

  if (!content || !content.children) {
    return <></>;
  }

  // n번째 div로 스크롤하는 함수
  const scrollToDiv = (n) => {
    if (divRefs.current[n]) {
      divRefs.current[n].current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  /**
   * 메뉴 클릭 시 메뉴 텍스트가 TopMenuBar 중앙에 오도록 스크롤
   */
  const scrollMenuItemToCenter = (index) => {
    // 메뉴 컴포넌트 컨테이너 DOM을 찾음
    const menuBarContainer = document.querySelector('.slide-top-menu-container');
    if (!menuBarContainer) return;

    // slide-top-menu-item은 각 메뉴 아이템에 사용됨
    const menuItems = menuBarContainer.querySelectorAll('.slide-top-menu-item');
    const menuItem = menuItems[index];
    if (menuItem && menuBarContainer) {
      // 메뉴바 내부 스크롤 위치를 조정: 아이템이 메뉴바 중앙에 오도록
      const containerWidth = menuBarContainer.offsetWidth;
      const itemLeft = menuItem.offsetLeft;
      const itemWidth = menuItem.offsetWidth;

      // 스크롤할 위치 계산
      const scrollLeft =
        itemLeft - containerWidth / 2 + itemWidth / 2;

      menuBarContainer.scrollTo({
        left: scrollLeft,
        behavior: 'smooth',
      });
    }
  };

  const containerStyle = {
    width: window.innerWidth <= 1024 ? "100%" : '1024px',
    margin: '0 auto',
    backgroundColor: "white",
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    WebkitOverflowScrolling: 'touch',
    position: 'relative',
    touchAction: 'pan-y',
  };

  return (
    content && (
      <Beforeunload onBeforeunload={(event) => event.preventDefault()}>
        <div ref={contentRef} style={containerStyle}>
          <TopMenuBar
            content={content}
            selectedIndex={selectedIndex}
            onMenuClick={(index) => {
              setSelectedIndex(index);
              scrollToDiv(index);
              scrollMenuItemToCenter(index);
            }}
            onClose={closePanel}
          />

          <TopArea
            imgPath={content["topImageUrl"]}
            name={content["title"]}
            subtitle={content["childrenReview"]}
          />

          <div className='pin-subtitle'>
            {content["subTitle"]}
          </div>

          <div className='pin-content'>
            {content["description"]}
          </div>

          <div style={{ marginBottom: "90px" }}>
            <ImageSlider images={content.images} />
          </div>

          {content.children && content.children.length > 0 && (
            <div
              style={{
                backgroundColor: '#faf2ed',
                borderRadius: content["topImageUrl"] ? '40px 0px 0px 0px' : '',
                padding: '0px 0px 50px 0px',
                paddingBottom: "70px"
              }}
            >
              {content.children.map((c, index) => (
                <div
                  key={index}
                  style={{ paddingTop: "70px" }}
                  ref={divRefs.current[index]}
                >
                  <PinChild
                    key={c.title}
                    content={c}
                    onLoad={() => {
                      if (selectedIndex === index) {
                        setImageLoaded(true);
                      }
                    }}
                  />
                </div>
              ))}
            </div>
          )}

          {/* <div id="Quick" >
            <a href="tel:031-767-5232">
              <img src={"tel.png"} style={{width:"224px", height:"80px"}} />
            </a>
          </div> */}
        </div>
      </Beforeunload>
    )
  );
};

export default PinContent;